import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "./Person";
import Receipt from "./Receipt";

export default class Factor extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			type: props.Type,
			data: null,
			loading: true,
			barcode: ''
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/factor/get", {
			id: this.state.id,
			type: this.state.type
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
					this.updateFormula();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;
		if (this.isBlank(this.state.data.record.number2)) this.state.data.record.number2 = 0;
		if (this.isBlank(this.state.data.record.discount)) this.state.data.record.discount = 0;
		if (this.isBlank(this.state.data.record.discountPercent)) this.state.data.record.discountPercent = 0;

		this.httpPost("api/v1/factor/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			personMoein: this.state.data.record.personMoein,
			personId: this.state.data.record.personId,
			number: this.state.data.record.number,
			number2: this.state.data.record.number2,
			date: this.convertMomentToDb(this.state.data.record.date),
			discount: this.state.data.record.discount,
			tprdis: this.state.data.record.tprdis,
			tdis: this.state.data.record.tdis,
			tvam: this.state.data.record.tvam,
			total: this.state.data.record.total,
			description: this.state.data.record.description,
			discountPercent: this.state.data.record.discountPercent,
			note: this.state.data.record.note,
			status: this.state.data.record.status,
			type: this.state.data.record.type,
			bodies: this.state.data.bodies,

			tprdis2: this.state.data.record.tprdis2,
			tdis2: this.state.data.record.tdis2,
			tvam2: this.state.data.record.tvam2,
			total2: this.state.data.record.total2,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("فاکتور با موفقیت ذخیره شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
			stuffId: this.defaultGuid(),
			stuffName: '',
			price: 0,
			price2: 0,
			currencyRate: this.state.data.currencyRate,
			count: 0,
			discount: 0,
			tax: 0,
			total: 0,
			prdis: 0,
			adis: 0,
			order: 0,
			taxRate: 0,
			description: '',
			warehouseId: this.defaultGuid(),
			warehouseName: '',
			unitId: this.defaultGuid(),
			unitName: '',
			modulusCount: 0,
		};
	}
	addBlankRow() {
		this.state.data.bodies.push(this.getBlankRow());
	}
	removeRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.bodies = temp;
		this.updateFormula();
	}
	copyRow(id) {
		var clone = null;
		this.state.data.bodies.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.bodies.length; i++) {
			if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
		}
		clone.index++;
		this.state.data.bodies.push(clone);
		this.updateFormula();
	}
	upIndex(id) {
		var idIndex = -1;
		this.state.data.bodies.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.bodies[idIndex].index;
			this.state.data.bodies[idIndex].index = ii - 1;
			this.state.data.bodies[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		var idIndex = -1;
		this.state.data.bodies.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
			var ii = this.state.data.bodies[idIndex].index;
			this.state.data.bodies[idIndex].index = ii + 1;
			this.state.data.bodies[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	setBodyValue(id, field, value) {
		for (var i = 0; i < this.state.data.bodies.length; i++) {
			if (this.state.data.bodies[i].id === id) {
				if (field == 'stuffId' || field == 'warehouseId' || field == 'unitId' || field == 'price') {
					if (field == 'stuffId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]['count'] = value.amount;
						if (this.isBlank(this.state.data.bodies[i]['count']))
							this.state.data.bodies[i]['count'] = 0;
						this.state.data.bodies[i]['unitId'] = value.unitId;
						this.state.data.bodies[i]['unitName'] = value.unitName;
						this.state.data.bodies[i]['taxRate'] = value.taxRate;
						this.state.data.bodies[i]['price'] = value.price;
						this.state.data.bodies[i]["stuffName"] = value.label;
						this.state.data.bodies[i]["description"] = value.description;
						this.state.data.bodies[i]['currencyRate'] = this.state.data.currencyRate;
						this.state.data.bodies[i]['price2'] = this.FixedPointNumber(parseInt(this.state.data.bodies[i]['price']) / this.state.data.currencyRate, 2);
					}
					if (field == 'warehouseId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["warehouseName"] = value.label;
					}
					if (field == 'unitId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["unitName"] = value.label;
					}
					if (field == 'price') {
						this.state.data.bodies[i][field] = value;
						this.state.data.bodies[i]['price2'] = this.FixedPointNumber(parseInt(this.state.data.bodies[i]['price']) / this.state.data.currencyRate, 2);
					}
				}
				else {
					this.state.data.bodies[i][field] = value;
				}
			}
		}
		this.updateFormula();
	}
	updateFormula() {
		var tprdis = 0;
		var tdis = 0;
		var tvam = 0;
		var total = 0;

		var tprdis2 = 0;
		var tdis2 = 0;
		var tvam2 = 0;
		var total2 = 0;
		var hasBlankRow = false;

		for (var i = 0; i < this.state.data.bodies.length; i++) {

			if (this.state.data.bodies[i].stuffId == this.defaultGuid()) hasBlankRow = true;

			this.state.data.bodies[i]['prdis'] = (this.state.data.bodies[i]['count'] * this.state.data.bodies[i]['price']);
			tprdis += this.state.data.bodies[i]['prdis'];
			tprdis2 += this.FixedPointNumber(this.state.data.bodies[i]['prdis'] / this.state.data.bodies[i]['currencyRate'], 2);

			this.state.data.bodies[i]['adis'] = this.state.data.bodies[i]['prdis'] - this.state.data.bodies[i]['discount'];
			tdis += this.state.data.bodies[i]['discount'];
			tdis2 += this.FixedPointNumber(this.state.data.bodies[i]['discount'] / this.state.data.bodies[i]['currencyRate'], 2);

			if (this.state.data.bodies[i]['taxRate'] > 0)
				this.state.data.bodies[i]['tax'] = this.FixedPointNumber((this.state.data.bodies[i]['adis'] * this.state.data.bodies[i]['taxRate']) / 100, 0);
			else
				this.state.data.bodies[i]['tax'] = 0;

			tvam += this.state.data.bodies[i]['tax'];
			tvam2 += this.FixedPointNumber(this.state.data.bodies[i]['tax'] / this.state.data.bodies[i]['currencyRate'], 2);

			this.state.data.bodies[i]['total'] = this.state.data.bodies[i]['tax'] + this.state.data.bodies[i]['adis'];
			total += this.state.data.bodies[i]['total'];
			total2 += this.FixedPointNumber(this.state.data.bodies[i]['total'] / this.state.data.bodies[i]['currencyRate'], 2);
		}
		this.state.data.record.tprdis = tprdis;
		this.state.data.record.tdis = tdis;
		this.state.data.record.tvam = tvam;
		this.state.data.record.total = total - this.state.data.record.discount;

		this.state.data.record.tprdis2 = tprdis2;
		this.state.data.record.tdis2 = tdis2;
		this.state.data.record.tvam2 = tvam2;
		this.state.data.record.total2 = total2;

		if (!hasBlankRow) this.addBlankRow();

		this.setState({ date: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	reciept(type) {
		this.removeKeyDown();
		this.showComponents({ component: <Receipt RefreshAfterSave={false} FactorId={this.state.data.record.id} Type={type} Caller={this} /> });
	}
	inputInvoiceByBarcodeReader(e) {
		e.preventDefault();
		if (!this.isBlank(this.state.barcode)) {
			this.httpPost("api/v1/stuff/get/barcode/", {
				barcode: this.state.barcode,
			})
				.then(data => {
					this.state.barcode = '';
					if (data.status === 1) {
						if (!this.isNull(data.record)) {
							var itemId = null;

							for (var i = 0; i < this.state.data.bodies.length; i++) {
								if (this.state.data.bodies[i].stuffId == this.defaultGuid())
									itemId = this.state.data.bodies[i].id;
							}

							this.setBodyValue(itemId, 'stuffId', data.record);
						}
					}
					this.setState({
						loading: false
					});
				});
		}
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body" style={{ "padding": "0" }}>
						<div className="panel panel-info center-block" style={{ "max-width": "none", "border": "none" }} >
							<div className="panel-heading">
								<b>
									{this.state.data.record.type === 2 && <span>فاکتور فروش</span>}
									{this.state.data.record.type === 1 && <span>فاکتور خرید</span>}
									{this.state.data.record.type === 4 && <span>فاکتور برگشت از فروش</span>}
									{this.state.data.record.type === 3 && <span>فاکتور برگشت از خرید</span>}
									{this.state.data.record.type === 5 && <span>فاکتور ضایعات</span>}
								</b>
							</div>
							<div className="panel-body">
								<div className="row">
									{this.state.data.record.type !== 5 && this.state.data.record.type !== 7 && this.state.data.record.type !== 8 && [
										//<div className="col-sm-3">
										//	<div className="form-group">
										//		<label for="invoiceDate" className="title1">معین طرف حساب <span className="red">*</span></label>
										//		<SelectAsync
										//			style={{ "width": "100%" }}
										//			defaultValue={!this.isNull(this.state.data.record.personMoeinAccount) ? [{ value: this.state.data.record.personMoeinAccount.fullCode, label: this.state.data.record.personMoeinAccount.title }] : null}
										//			isMulti={false}
										//			placeholder="انتخاب معین طرف حساب"
										//			defaultOptions
										//			loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
										//			onChange={e => this.state.data.record.personMoein = e.value}
										//		/>
										//	</div>
										//</div>
										,
										<div className="col-sm-6">
											<div className="form-group">
												<label for="invoiceContact" className="title1">طرف حساب<span className="red">*</span></label>
												<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
												{((this.state.data.record.type !== 4 && this.state.data.record.type !== 3) || this.isNull(this.state.data.refInvoice)) ?
													<SelectAsync
														value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
														isMulti={false}
														placeholder="انتخاب طرف حساب"
														defaultOptions
														loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
														onChange={e => this.setPerson(e)}
													/>
													:
													<div id="invoiceComboContact">{this.state.data.refInvoice.person.name}</div>}
											</div>
										</div>
									]}
									<div className="col-sm-6">
										<div className="row">
											<div className="col-sm-2">
												<div className="form-group">
													<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
													<DatePicker
														inputReadOnly={true}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.data.record.date = e }}
														value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
													/>
												</div>
											</div>
											<div className="col-sm-2">
												<div className="form-group">
													<label for="invoiceNumber" className="title1">شماره فاکتور</label>
													<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
												</div>
											</div>
											<div className="col-sm-2">
												<div className="form-group">
													<label for="invoiceNumber" className="title1">وضعیت</label>
													<select onChange={e => this.state.data.record.status = parseInt(e.target.value)} defaultValue={this.state.data.record.status} className="form-control input-smnumber">
														<option value="1">پیش نویس</option>
														<option value="2">نهایی</option>
													</select>
												</div>
											</div>
											<div className="col-sm-2">
												<div className="form-group">
													<label for="invoiceReference" className="title1" style={{ "white-space": "nowrap" }} >
														ارجاع
														{(this.state.data.record.type === 1 || this.state.data.record.type === 3) &&
															<small className="hidden-md hidden-sm">(شماره فاکتور خرید)</small>
														}
														{(this.state.data.record.type === 2 || this.state.data.record.type === 4) &&
															<small className="hidden-md hidden-sm">(شماره فاکتور فروش)</small>
														}
													</label>
													{(this.state.data.record.type === 4 || this.state.data.record.type === 3) ?
														this.isBlank(this.state.data.record.number2) ?
															<input onChange={e => this.state.data.record.number2 = parseInt(e.target.value)} defaultValue={this.state.data.record.number2} autocomplete="off" type="text" className="form-control input-smnumber" value="" id="invoiceReference" />
															:
															<input onChange={e => this.state.data.record.number2 = parseInt(e.target.value)} defaultValue={this.state.data.record.number2} autocomplete="off" type="text" className="form-control input-smnumber" disabled id="invoiceReference" />
														:
														<input onChange={e => this.state.data.record.number2 = parseInt(e.target.value)} defaultValue={this.state.data.record.number2} autocomplete="off" type="text" className="form-control input-smnumber" id="invoiceReference" />
													}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mr-b-20">
									{this.state.data.record.type !== 5 &&
										<div className="col-md-12">
											<label className="title1">توضیحات</label>
											<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "100%" }} maxlength="150" />
										</div>
									}
									<div className="col-md-4">
										<label className="title1">ورود بارکدخوان</label>
										<form key={"barcode_"+this.state.barcode} onSubmit={e => this.inputInvoiceByBarcodeReader(e)}>
											<input autocomplete="off" onChange={e => this.state.barcode = e.target.value} defaultValue={this.state.barcode} type="text" placeholder="بارکد کالا ..." className="form-control" style={{ "width": "100%" }} maxlength="150" />
											<input autocomplete="off" type="submit" className="ng-hide" />
										</form>
									</div>
								</div>
								<table className="table table-bordered">
									<thead>
										<tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
											<td>#</td>
											<td>آیتم<span className="red">*</span></td>
											{this.state.data.global.company.warehouseSystem &&
												<td>انبار کالا<span className="red">*</span></td>
											}
											<td>شرح</td>
											<td style={{ "width": "80px" }}>
												<span>تعداد/مقدار<span className="red">*</span></span>
											</td>
											<td>واحد اندازه گیری<span className="red">*</span></td>
											<td style={{ "width": "120px" }}>مبلغ واحد <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
											<td style={{ "width": "90px" }}>نرخ ارز <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
											<td style={{ "width": "90px" }}>مبلغ ارزی <span style={{ "font-weight": "normal" }} >(دلار)</span><span className="red">*</span></td>

											{this.state.data.record.type !== 5 && <td style={{ "width": "100px" }}>تخفیف</td>}
											{this.state.data.record.type !== 5 && <td style={{ "width": "120px" }}>مبلغ بعد از تخفیف</td>}
											{this.state.data.record.type !== 5 && <td style={{ "width": "100px" }}>مالیات</td>}

											<td style={{ "width": "120px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
											<td></td>
										</tr>
									</thead>
									<tbody>
										{this.state.data.bodies.sort((a,b)=>a.index-b.index).map((item, index) =>
											<tr key={item.id} className="accDataEntryGridRow invoice_grid_row" style={{ "font-size": "9pt", "font-weight": "bold" }}>
												<td>
													<span className="inGridRowNumber">{(index + 1)}</span>
													<div style={{ "font-size": "9pt", "color": "silver" }}>
														{index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
														{index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
													</div>
												</td>
												<td key={"stuff_"+item.stuffId }>
													<SelectAsync
														defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
														isMulti={false}
														placeholder="انتخاب آیتم"
														defaultOptions
														loadOptions={this.loadStuffsOptions}
														onChange={e => this.setBodyValue(item.id,'stuffId', e)}
													/>
												</td>
												{this.state.data.global.company.warehouseSystem &&
													<td key={"warehouse_" +item.warehouseId }>
														<SelectAsync
															defaultValue={item.warehouseId != this.defaultGuid() ? [{ value: item.warehouseId, label: item.warehouseName }] : null}
															isMulti={false}
															placeholder="انتخاب انبار"
															defaultOptions
															loadOptions={this.loadWarehousesOptions}
															onChange={e => this.setBodyValue(item.id,'warehouseId', e)}
														/>
													</td>
												}
												<td key={"description_" + item.stuffId + "_" + item.description}>
													<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id,'description', e.target.value)} />
												</td>
												<td key={"count_" + item.stuffId + "_" + item.count}>
													<NumberFormat value={item.count} onChange={e => this.setBodyValue(item.id,'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
												</td>
												<td key={"unit_" +item.unitId }>
													<SelectAsync
														defaultValue={item.unitId != this.defaultGuid() ? [{ value: item.unitId, label: item.unitName }] : null}
														isMulti={false}
														placeholder="واحد اندازه گیری"
														defaultOptions
														loadOptions={this.loadUnitsOptions}
														onChange={e => this.setBodyValue(item.id,'unitId', e)}
													/>
												</td>
												<td><NumberFormat value={item.price} onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>
												<td><NumberFormat readOnly={true} value={item.currencyRate} onChange={e => this.setBodyValue(item.id, 'currencyRate', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>
												<td><NumberFormat readOnly={true} value={item.price2} onChange={e => this.setBodyValue(item.id, 'price2', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>
												{this.state.data.record.type !== 5 && <td><NumberFormat value={item.discount} onChange={e => this.setBodyValue(item.id, 'discount', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>}
												{this.state.data.record.type !== 5 && <td><NumberFormat readOnly={true} value={item.adis} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>}
												{this.state.data.record.type !== 5 && <td><NumberFormat readOnly={true} value={item.tax} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>}
												<td>
													<NumberFormat readOnly={true} value={item.total} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
												</td>
												<td>
													{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
													{item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
												</td>
											</tr>
										)}
									</tbody>
								</table>
								<div className="row" style={{ "padding-left": "15px" }} >
									<div className="col-lg-6 col-md-12 col-sm-12">
										<div className="row">
											<div className="col-md-12 text-right">
												<table className="ng-hide">
													<tbody>
														<tr>
															<td>
																<div className="form-inline ng-pristine ng-valid" style={{ "margin-right": "5px" }} >
																	<div className="form-group">
																		<div className="input-group">
																			<div className="input-group-addon hand">
																				%
																			</div>
																			<div>
																				<input onChange={e => this.state.data.record.discountPercent = e.target.value} defaultValue={this.state.data.record.discountPercent} autocomplete="off" onblur="DiscountApply(1)" type="text" className="form-control input-sm ng-valid" placeholder="تخفیف" style={{ "width": "60px" }} /></div>
																		</div>
																	</div>
																</div>
															</td>
															<td>
																<div className="form-inline ng-pristine ng-valid" style={{ "margin-right": "5px" }} >
																	<div className="form-group">
																		<div className="input-group">
																			<div className="input-group-addon hand">
																				{this.state.data.global.company.currencyUnit}
																			</div>
																			<div>
																				<input onChange={e => this.state.data.record.discount = e.target.value} defaultValue={this.state.data.record.discount} autocomplete="off" onblur="DiscountApply(2)" type="text" className="form-control input-sm ng-valid" placeholder="تخفیف" style={{ "width": "120px" }} /></div>
																		</div>
																	</div>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="row mr-t-10">
											<div className="col-md-2 ltr text-right">
											</div>
										</div>
										<div className="form-group" style={{ "padding-left": "50px" }} >
											<label className="title1" for="comment">یادداشت</label>
											<textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
										</div>
									</div>
									<div className="col-lg-3 col-md-12 col-sm-12" style={{ "padding": "0" }} >
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >مجموع <span style={{ "font-weight": "normal" }} >(ارزی)</span></div>
											<div className="col-xs-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tprdis2)}</div>
										</div>
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >مجموع تخفیفات <span style={{ "font-weight": "normal" }} >(ارزی)</span></div>
											<div className="col-xs-6 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.state.data.record.tdis2)})</div>
										</div>
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >جمع مالیات<span style={{ "font-weight": "normal" }} >(ارزی)</span></div>
											<div className="col-xs-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tvam2)}</div>
										</div>
										<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "1px" }} ></div>
										<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
											<div className="col-xs-6 h5 txt-bold" style={{ "padding": "0" }}>مبلغ نهایی<span style={{ "font-weight": "normal" }} >(ارزی)</span></div>
											<div className="col-xs-6 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total2)}</div>
											<div className="col-xs-6 h5 txt-bold" style={{ "padding": "0" }}>مانده<span style={{ "font-weight": "normal" }} >(ارزی)</span></div>
											<div className="col-xs-6 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total2 - this.state.data.totalReciept2)}</div>
										</div>
										<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
									</div>
									<div className="col-lg-3 col-md-12 col-sm-12" style={{ "padding": "0" }} >
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >مجموع <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
											<div className="col-xs-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tprdis)}</div>
										</div>
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >مجموع تخفیفات <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
											<div className="col-xs-6 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.state.data.record.tdis)})</div>
										</div>
										<div className="row text-left">
											<div className="col-xs-6 title1" style={{ "padding": "0" }} >جمع مالیات<span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
											<div className="col-xs-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tvam)}</div>
										</div>
										<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "1px" }} ></div>
										<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
											<div className="col-xs-6 h5 txt-bold" style={{ "padding": "0" }}>مبلغ نهایی<span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
											<div className="col-xs-6 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total)}</div>
											<div className="col-xs-6 h5 txt-bold" style={{ "padding": "0" }}>مانده<span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
											<div className="col-xs-6 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total-this.state.data.totalReciept)}</div>
										</div>
										<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
									</div>
								</div>
							</div>

							<div className="panel-footer">
								<div className="row">
									<div className="col-sm-8 text-right">
										<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)}>ذخیره</button>
										{this.state.data.record.id !== this.defaultGuid() && this.state.data.record.type === 2 &&
											<button type="button" className="hand btn btn-warning" onClick={e=>this.reciept(1)} style={{ "marginRight":"10px" }}>دریافت</button>
										}
										{this.state.data.record.id !== this.defaultGuid() && this.state.data.record.type === 1 &&
											<button type="button" className="hand btn btn-warning" onClick={e => this.reciept(2)} style={{ "marginRight": "10px" }}>پرداخت</button>
										}
										&nbsp;
										{this.state.data.record.id !== this.defaultGuid() && this.state.data.record.type === 2 && [
											<a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('print', '/api/v1/factor/export/' + this.state.data.record.id) }>
												<span className="fa fa-print" aria-hidden="true"></span>&nbsp;
												چاپ
											</a>
											,
											<a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('pdf', '/api/v1/factor/export/' + this.state.data.record.id)}>
												<span className="fa fa-file-pdf-o" aria-hidden="true"></span>&nbsp;
												PDF
											</a>
										]
										}
									</div>
									<div className="col-sm-4 text-left">
										{this.state.data.record.type != 5 &&
											<a className="btn btn-default btn-smoke" style={{ "width": "80px" }} onClick={e => this.closeMe()}>انصراف</a>
										}
									</div>
								</div>
							</div>
						</div >
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}